var _style, _path, _path2, _path3, _path4, _g, _path5, _g2, _g3, _path6, _g4, _path7, _g5, _use, _use2, _g6, _ellipse, _g7, _g8, _g9, _path8, _path9, _g10, _path10, _g11, _path11, _g12, _use3, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _use4, _g23, _use5, _g24, _use6, _use7, _use8, _g25, _path12, _g26, _g27, _g28, _path13, _g29, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".e{stroke-width:.15}.f{fill:none}.g{stroke-width:.3}.h{fill:#fff}.i{fill:#f1b517}.j{stroke-width:.265}.k{stroke:#000}.l{fill:#d21034}.m{stroke-width:.325}.n{fill:#0a328c}.o{fill:#00209f}.p{stroke-width:.163}.q{stroke-width:.287}.r{stroke-linecap:round}.s{fill:#016a16}.t{stroke-width:.125}.u{stroke-width:.157}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M0 0h1000v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M0 0h1000v300H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M405.17 222.41h189.66v155.17H405.17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M499.613 332.337v.084c-4.078.43-47.873 5.227-59.775 14.111-12.48 9.316-34.666 19.076-34.666 19.076v11.978h189.657v-11.978s-22.186-9.76-34.666-19.076c-11.901-8.884-55.697-13.68-59.775-14.111v-.084l-.387.042-.387-.042z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 74.462 264.55)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5.7 529.3 67.882)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  }))), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f m",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4.2 502.69 103.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5.7 529.3 67.882)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  }))), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f m",
    xlinkHref: "#H"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m474.28 323.75 1.375 13.245 17.296-1.122z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(-.864 0 0 .84 925.67 265.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.109 52.433s-1.457 25.124-9.103 37.747l-31.193-4.612.85-15.293 39.446-26.824z"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j k",
    xlinkHref: "#I"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(-.864 0 0 .84 925.67 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g l",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e n",
    xlinkHref: "#K"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m497.639 327.661-20.616-18.287c-4.601 1.966-4.247 5.541-1.06 10.034l-.097 4.501 16.859 11.441 4.624-1.126.193-4.126zm-.629-11.776-12.634-15.847-3.196 6.902.998 6.514 15.081 13.805z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.864 0 0 .84 925.67 265.06)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j k",
    xlinkHref: "#M"
  })), /*#__PURE__*/React.createElement("use", {
    className: "e k l",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("use", {
    className: "i",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#Q"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("use", {
    className: "t",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 551.15,
    cy: 100.3,
    r: 2.391
  }))), /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#U"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M448.38 305.42c-.544-9.136 1.088-19.861 1.088-19.861l.136-1.589 28.155 26.216s-1.908 2.785-1.625 13.901l-2.183-1.455z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.864 0 0 .84 925.67 265.06)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f j",
    d: "M552.633 48.008c.63-10.867-1.26-23.624-1.26-23.624l-.157-1.89"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9.1 474.55 126.57)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(19 458.58 111.38)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m534.065 11.472-37.87 48.098.245.746 38.215-48.382zm16.353 11.757-54.756 50.793.51.551 54.756-50.795zm8.814 20.339-58.293 39.898.424.619 58.293-39.898z"
  })), /*#__PURE__*/React.createElement("use", {
    className: "j n",
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#Z"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AE"
  })), /*#__PURE__*/React.createElement("use", {
    className: "f g",
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e n",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j l",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M553.886 36.096s.678-3.052-.882-5.765c-1.571-2.773-2.04-6.993-1.221-6.714"
  })), /*#__PURE__*/React.createElement("use", {
    className: "i u",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i",
    xlinkHref: "#AF"
  }), /*#__PURE__*/React.createElement("use", {
    className: "h",
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.898 .118 -.12 .874 251.92 243.36)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "e i",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    className: "r",
    fill: "#f4cf0e",
    strokeWidth: 0.13,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#AG"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 32.942,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.898 .118 -.12 .874 251.92 243.36)",
    xlinkHref: "#j"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    className: "e i k",
    transform: "matrix(.898 .118 -.12 .874 251.92 243.36)",
    xlinkHref: "#k"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 74.978 265.68)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e i k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 86.476,
    r: 2.282
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 445.45 86.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(45 0 -989.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 359.15 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 -1) rotate(-67.935 317.35 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(113.4 445.45 86.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(23 445.45 86.298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(23.078 0 -2095.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "e i k",
    transform: "scale(-1 1)",
    cx: -444.64,
    cy: 349.39,
    rx: 2.065,
    ry: 2.01
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 75.483 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "e h k",
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e h k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AI"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.864 0 0 .84 925.67 265.06)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(-1 0 0 1 984.54 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 472.44,
    cy: 104.75,
    rx: 3.569,
    ry: 1.681
  }), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AJ"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m524.272 96.459.589-.094.47 2.095-.59.094z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g h",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 523.95,
    cy: 109.88,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.65,
    cy: 105.09,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.43,
    cy: 105.66,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.1,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.92,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.74,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.55,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.07,
    cy: 104.87,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.88,
    cy: 104.87,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.7,
    cy: 104.87,
    r: 2.391
  })), /*#__PURE__*/React.createElement("use", {
    className: "g l",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    className: "n",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AM"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  })))), /*#__PURE__*/React.createElement("use", {
    className: "i",
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AA"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g n",
    xlinkHref: "#AB"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#AC"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AN"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M561.609 43.805s.463 1.966.578 6.071-.752 6.881-1.099 6.823"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#AD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M537.9 24.955s1.388 5.724 1.561 8.384"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M527.16 13.193s1.413-1.925 5.589-.246"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q s",
    d: "m497.388 269.78.656-20.966 3.06-1.596.875 22.561z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m n",
    d: "M498.643 229.63s-.295 0-.788-.48-.788-.479-.394-1.15.887-1.535 2.562-1.44 2.957.193 3.547 1.92.788 6.331.296 8.25c-2.563-.096-6.405-2.11-6.996-3.453s1.773-3.646 1.773-3.646z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.863 0 0 .84 924.885 264.554)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5.7 529.3 67.882)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  }))), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f m",
    xlinkHref: "#H"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4.2 502.69 103.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5.7 529.3 67.882)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i m",
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    className: "m",
    xlinkHref: "#A"
  }))), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e h",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f m",
    xlinkHref: "#H"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M502.091 230.339s-2.07.383-1.97 1.343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.107 228.191s-2.365.576-3.153 2.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.023 228.479s-1.38 1.15-1.971.767"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m497.697 231.254-.138.008-.274.075c-.394.656-.662 1.38-.416 1.939.042.096.102.195.176.297l.218-.105s4.532-.383 6.503 2.974l.118.2c.188-.79.267-1.987.258-3.252-3.14-2.104-5.818-2.157-6.445-2.136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f r",
    d: "M502.979 231.394s-1.084.48-1.084.959"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m524.66 324.14-.314 12.857-17.296-1.122z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M558.94 309.14s-1.258 21.122-7.862 31.735l-26.94-3.877.734-12.857 34.068-22.552z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j n",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("use", {
    className: "g l",
    xlinkHref: "#J"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e n",
    xlinkHref: "#K"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m502.36 327.661 20.616-18.287 3.049 6.875-1.893 7.661-16.859 11.441-4.624-1.126-.193-4.126zm.629-11.776 12.634-15.847 3.196 6.902-.998 6.514-15.081 13.805z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "o",
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j n",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e l",
    xlinkHref: "#N"
  })), /*#__PURE__*/React.createElement("use", {
    className: "i",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#Q"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("use", {
    className: "t",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 551.15,
    cy: 100.3,
    r: 2.391
  }))), /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#U"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M551.62 305.42c.544-9.136-1.088-19.861-1.088-19.861l-.136-1.589-28.155 26.216s2.04-2.119 1.36 8.738l2.448 3.708z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f j",
    d: "M551.62 305.42c.544-9.136-1.088-19.861-1.088-19.861l-.136-1.589"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9.1 474.55 126.57)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(19 458.58 111.38)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#V"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36.2 196.43 -35.139)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e",
    xlinkHref: "#X"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m534.065 11.472-37.87 48.098.197.833 38.263-48.469zm16.353 11.757-54.756 50.793.51.551 54.756-50.795zm8.814 20.339-58.293 39.898.424.619 58.293-39.898z"
  })), /*#__PURE__*/React.createElement("use", {
    className: "j n",
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#Z"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AE"
  })), /*#__PURE__*/React.createElement("use", {
    className: "f g",
    xlinkHref: "#Y"
  }), /*#__PURE__*/React.createElement("use", {
    className: "e n",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j l",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f g",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e f",
    d: "M552.7 295.4s.586-2.566-.762-4.847c-1.357-2.331-1.762-5.879-1.055-5.645"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i u",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("use", {
    className: "i",
    xlinkHref: "#AF"
  }), /*#__PURE__*/React.createElement("use", {
    className: "h",
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.898 .118 .12 .874 748.08 243.36)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "e i",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    className: "r",
    fill: "#f4cf0e",
    strokeWidth: 0.13,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f j",
    xlinkHref: "#AG"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 32.942,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  }))))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.898 .118 .12 .874 748.08 243.36)",
    xlinkHref: "#j"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "i k e"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.898 .118 .12 .874 748.08 243.36)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.864 0 0 .84 925.02 265.68)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 86.476,
    r: 2.282
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -540.3,
    cy: 327.17,
    rx: 0.416,
    ry: 0.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -540.3,
    cy: 349.3,
    rx: 0.416,
    ry: 0.405
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.61 .594 .61 .594 759.64 22.119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.61 .594 -.61 .594 320.97 22.119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 .84 -.864 0 614.84 -36.268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.324 .78 -.8 -.316 753.9 18.418)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.343 .772 .793 -.334 319.16 23.314)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.795 .33 .339 .773 865.02 124.69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.795 .33 -.339 .773 215.59 124.69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 73.138,
    r: 0.482
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.45,
    cy: 99.458,
    r: 0.482
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "e k"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 555.36,
    cy: 349.39,
    rx: 2.065,
    ry: 2.01
  }), /*#__PURE__*/React.createElement("use", {
    className: "h",
    transform: "matrix(-.864 0 0 .84 924.52 265.06)",
    xlinkHref: "#n"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.864 0 0 .84 924.52 265.06)",
    xlinkHref: "#o"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e h",
    transform: "matrix(-.864 0 0 .84 924.52 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AH"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AI"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(-.864 0 0 .84 924.64 265.06)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 472.44,
    cy: 104.75,
    rx: 3.569,
    ry: 1.681
  }), /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AJ"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "j",
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m524.272 96.459.589-.094.47 2.095-.59.094z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AK"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AL"
  }))))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#s"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g h",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e i",
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 523.95,
    cy: 109.88,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.65,
    cy: 105.09,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.43,
    cy: 105.66,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.1,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 550.92,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.74,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.55,
    cy: 109.31,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.07,
    cy: 104.87,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.88,
    cy: 104.87,
    r: 2.391
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.7,
    cy: 104.87,
    r: 2.391
  })), /*#__PURE__*/React.createElement("use", {
    className: "g l",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "n",
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AM"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  }))))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    className: "i",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#y"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#z"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#AA"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g n",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#AB"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(.864 0 0 .84 74.329 265.06)"
  }, /*#__PURE__*/React.createElement("use", {
    className: "l",
    xlinkHref: "#AC"
  }), /*#__PURE__*/React.createElement("use", {
    className: "f",
    xlinkHref: "#AN"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("use", {
    className: "g",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M559.367 301.885s.4 1.653.499 5.104-.649 5.785-.949 5.736"
  }), /*#__PURE__*/React.createElement("use", {
    className: "j",
    transform: "matrix(.864 0 0 .84 74.329 265.06)",
    xlinkHref: "#AD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M538.89 286.04s1.199 4.812 1.348 7.049"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.124
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M525.579 323.156s1.362-1.43 1.449-2.04.065-1.619-.779-1.64-4.845-.673-6.055.273-1.428 1.43-1.19 1.914 1.233 1.261 2.054 1.22 1.623.315 1.947.125 1.73-1.808 2.098-.358l.043.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.715 328.593s.82-3.809 2.187-5.492c0 0 1.731-.443 2.369 0s-.09-.532.638.354.729 4.253.729 4.253l.911.797c-2.369 1.064-6.835.088-6.835.088z",
    fill: "#f1b617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.366 328.4c-2.187 1.151-6.653.265-6.653.265s-.729 1.683 0 1.418.365.62 1.094 0 .73-.797.73-.797 4.192 0 5.011-.266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M524.367 323.65a4.674 4.544 0 0 0 .667.11m-.686.368s.29.071.664.102m-.683.375a4.355 4.234 0 0 0 .662.092m-.681.385s.279.063.66.084m-.68.394a4.139 4.024 0 0 0 .658.075m-.676.402s.268.056.655.066m-.674.411s.261.052.653.058m-.672.42a3.966 3.856 0 0 0 .65.048m-.67.43s.251.042.65.039m-.668.438s.245.038.646.03m-.665.447s.239.034.643.022m.903-4.596c.28-.042.533-.144.68-.349m-.718.808c.314-.05.618-.163.832-.389m-.87.848c.348-.055.703-.18.984-.428m-1.022.888a2.5 2.5 0 0 0 1.135-.468m-1.173.927a3.08 2.995 0 0 0 1.288-.507m-1.326.966a3.741 3.637 0 0 0 1.44-.547m-1.478 1.006a4.45 4.326 0 0 0 1.59-.586m-1.628 1.046a5.21 5.065 0 0 0 1.743-.626m-1.78 1.085a5.979 5.813 0 0 0 1.893-.666m-1.932 1.125a6.794 6.605 0 0 0 2.046-.706m-2.084 1.165a7.66 7.447 0 0 0 2.198-.745"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d20014"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m524.086 321.642-1.449 1.345m.515-1.375-.956 1.329m.022-1.358-.463 1.312m-.472-1.342.03 1.296m-.965-1.325.524 1.278m-1.458-1.307 1.017 1.261M519.955 321.6l.627 1.198"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e f",
    d: "M529.61 276.15s1.22-1.618 4.827-.207"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M502.309 269.675s1.468 46.23.267 63.598m-.267-63.598c-1.743-.255-4.662 0-4.662 0s-1.468 46.23-.267 63.598c0 0 3.187-.383 5.195 0",
    strokeWidth: 0.258
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m499.835 271.808-.936.01-1.318.039-.006.222 4.804-.008-.006-.223-2.538-.041zm-.025 1.619-.933.009-1.34.036-.006.223 4.893-.002-.006-.223-2.608-.043zm-.026 1.62-.929.008-1.362.033-.006.223 4.981.004-.006-.223zm-.026 1.62-.926.006-1.384.029-.006.223 5.07.01-.006-.223zm-.949 1.625-1.402.026-.005.223 5.148.015-.006-.223zm-.022 1.617-1.418.022-.006.223 5.225.02-.005-.223zm-.023 1.619-1.433.018-.006.223 5.301.026-.006-.223-3.857-.044zm-.024 1.619-1.448.015-.005.221 5.378.031-.006-.222zm-.022 1.617-1.464.01-.005.223 5.454.036-.005-.224-3.98-.046zm-.022 1.62-1.476.006-.005.222 5.521.041-.005-.222zm-.024 1.618a177.4 177.4 0 0 0-1.485.002l-.005.223 5.587.046-.005-.223-4.093-.048zm-.022 1.619c-.625-.003-1.005 0-1.496.001l-.005.222 5.652.047-.005-.222zm-1.525 1.615-.004.222 5.708.051-.004-.222-5.701-.051zm-.028 1.613-.004.223 5.765.055-.004-.222zm-.028 1.612-.004.223 5.82.061-.004-.223-5.813-.06zm-.024 1.611-.003.223 5.867.066-.003-.223zm-.023 1.615-.003.222 5.913.069-.003-.223zm-.023 1.612-.003.223 5.958.071-.003-.222zm-.02 1.618-.002.222 5.996.07-.002-.222c-2.429.005-4.538-.031-5.991-.07zm-.016 1.613-.002.223 6.028.07-.002-.222a164.635 160.263 0 0 1-6.023-.07zm-.016 1.614-.002.222 6.06.071-.002-.222a140.83 140.83 0 0 1-6.055-.071zm-.015 1.614v.223l6.087.075v-.224c-2.491.033-4.623-.017-6.085-.074zm-.008 1.613v.223l6.103.077v-.224a103.32 103.32 0 0 1-6.102-.075zm-.008 1.615v.223l6.12.076-.002-.222a90.12 90.12 0 0 1-6.118-.077zm-.008 1.614-.002.223 6.136.075v-.223a81.617 81.617 0 0 1-6.134-.076zm0 1.615v.223l6.133.074v-.223a71.697 69.793 0 0 1-6.134-.075zm.002 1.615v.223l6.13.074v-.223a66.973 66.973 0 0 1-6.13-.074zm.002 1.614v.223a61.68 61.68 0 0 0 6.126.073v-.223c-2.538.094-4.666.02-6.126-.073zm.01 1.617.002.223a57.28 57.28 0 0 0 6.102.07l.002-.223c-2.53.104-4.651.028-6.106-.07zm.014 1.617.002.223a53.16 53.16 0 0 0 6.074.067l.002-.222a52.91 52.91 0 0 1-6.078-.068zm.014 1.617.002.223a48.361 47.076 0 0 0 6.045.064l.002-.223c-2.51.123-4.603.043-6.049-.064zm.022 1.618.004.222c1.446.112 3.516.192 5.999.061l.004-.223a46.307 46.307 0 0 1-6.006-.06zm.028 1.617.005.224c1.438.116 3.484.195 5.941.057l.005-.223a43.52 43.52 0 0 1-5.95-.057zm.036 1.62.005.223a41.4 41.4 0 0 0 5.869.052l.005-.222a40.937 40.937 0 0 1-5.879-.053zm.045 1.621.006.222c1.414.121 3.396.198 5.777.046l.006-.222c-2.393.154-4.38.075-5.789-.047zm.053 1.622.009.223a37.11 37.11 0 0 0 5.665.039l.008-.222a36.8 36.8 0 0 1-5.682-.041zm.065 1.623.011.224c1.378.122 3.27.191 5.531.034l.011-.225c-2.279.16-4.178.089-5.553-.033zm.08 1.626.014.224a33.053 32.175 0 0 0 5.367.025l.014-.224c-2.201.16-4.044.095-5.394-.025z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m501.188 330.856 1.086.099m-1.082-1.708 1.104.094m-1.1-1.702 1.122.089m-1.118-1.698 1.14.085m-1.136-1.694 1.159.08m-1.155-1.688 1.177.076m-1.173-1.685 1.195.072m-1.191-1.68 1.214.066m-1.21-1.675 1.232.062m-1.228-1.67 1.25.057m-1.246-1.666 1.269.054m-1.265-1.662 1.287.05m-1.283-1.659 1.305.045m-1.301-1.653 1.324.04m-1.32-1.65 1.342.036m-1.338-1.644 1.36.031m-1.356-1.639 1.378.027m-1.374-1.636 1.397.022m-1.432-1.63 1.415.017m-1.452-1.626 1.434.012m-1.47-1.62 1.451.008m-1.488-1.616 1.47.004m-1.508-1.612h1.489m-1.526-1.608 1.507-.005m-1.545-1.603 1.527-.01m-1.563-1.6 1.544-.014m-1.58-1.594 1.562-.019m-1.6-1.589 1.582-.023m-1.618-1.585 1.6-.028m-1.637-1.58 1.618-.033m-1.654-1.576 1.636-.038m-1.673-1.571 1.654-.041m-1.69-1.567 1.672-.046m-1.71-1.562 1.692-.05m-1.728-1.559 1.71-.055m-1.745-1.553 1.728-.06m-1.765-1.548 1.746-.064m-1.782-1.544 1.764-.069m-4.653 59.672 1.086.098m-1.12-1.712 1.105.094m-1.138-1.707 1.122.089m-1.155-1.703 1.14.085m-1.174-1.698 1.16.08m-1.193-1.693 1.177.076m-1.21-1.69 1.195.071m-1.23-1.684 1.215.066m-1.248-1.68 1.233.062m-1.266-1.675 1.25.058m-1.283-1.671 1.268.053m-1.302-1.667 1.287.05m-1.32-1.663 1.305.044m-1.34-1.658 1.324.04m-1.358-1.653 1.342.035m-1.376-1.65 1.36.032m-1.366-1.645 1.378.027m-1.35-1.64 1.396.022m-1.369-1.635 1.416.017m-1.388-1.63 1.434.012m-1.406-1.626 1.452.009m-1.424-1.621 1.47.004m-1.442-1.618h1.488m-1.46-1.613 1.507-.005m-1.48-1.608 1.527-.01m-1.498-1.604 1.545-.014m-1.516-1.599 1.563-.019m-1.534-1.594 1.58-.023m-1.552-1.59 1.6-.028m-1.571-1.585 1.618-.033m-1.59-1.58 1.636-.038m-1.607-1.576 1.654-.041m-1.625-1.572 1.672-.046m-1.643-1.567 1.69-.05m-1.662-1.564 1.71-.055m-1.681-1.558 1.727-.06m-1.7-1.552 1.746-.064m-1.717-1.549 1.764-.068",
    strokeWidth: 0.515
  }), /*#__PURE__*/React.createElement("path", {
    className: "i p",
    d: "M492.34 336.6h15.28v13.89h-15.28z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.995 98.215c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179m-3.601-.781c1.258 0 2.476-.063 3.601-.179",
    fill: "#d20014",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M511.57 96.544c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065m2.957-2.035c-.732.416-1.744.779-2.957 1.065",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M497.584 84.5c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.093c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.093c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.093c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.093c-1.807-.246-3.353-.638-4.474-1.126m4.474 2.092c-1.807-.246-3.353-.638-4.474-1.126",
    opacity: 0.98,
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l p",
    d: "M499.889 332.473c-2.078 0-4.07.21-5.54.583-1.469.373-2.294.877-2.294 1.405a.616.616 0 0 0 .124.335v1.902a.616.616 0 0 0-.124.336c0 .117.042.234.124.35v.363h.4c1.164.767 4.07 1.273 7.31 1.273 3.24 0 6.14-.507 7.302-1.273h.483v-.5a.573.558 0 0 0 .048-.213.581.566 0 0 0-.048-.188v-2.198a.581.566 0 0 0 .048-.187c0-.528-.825-1.032-2.294-1.405-1.47-.373-3.462-.583-5.54-.583zm0 1.344.487.006.397.008.348.013.426.02.359.023.384.028.39.036.334.034.395.048.305.04.391.061.268.044.33.064.213.041h-.012c1.065.226 1.875.518 2.348.849-1.115.788-4.06 1.315-7.362 1.316-3.302 0-6.245-.527-7.363-1.315.929-.656 3.147-1.14 5.843-1.276l.774-.03.746-.009z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502 77.416c-4.147.001-7.844.68-9.244 1.697 1.404 1.016 5.1 1.693 9.244 1.695s7.844-.68 9.244-1.697c-1.404-1.016-5.1-1.693-9.244-1.695z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.781 75.686-.789.011v1.735l.789-.015zm5.389.383v1.736l.789.142V76.21l-.789-.142zm-10.91.098-.788.165v1.733l.788-.164zm11.961 4.058-.92.173v3.32l.92-.173zm-9.07.47v3.322l.92.061v-3.322z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.771 97.18c-.364.222-.855.431-1.457.62-1.794.747-4.935 1.202-8.318 1.204-3.367-.001-6.498-.451-8.298-1.192-.561-.176-1.025-.369-1.381-.574v2.091a.807.807 0 0 0-.156.433.799.799 0 0 0 .156.451v.47h.502c1.462.989 5.11 1.642 9.178 1.642 4.068 0 7.708-.654 9.168-1.642h.607v-.646a.72.72 0 0 0 .059-.274.73.73 0 0 0-.059-.242z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.513 82.722v2.872l3.521 12.879.825.147z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.186 84.019-3.108 14.462.746.133 3.128-14.544-.767-.052zm8.759-.419-.82.146-3.807 15.231.79-.035z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.175 84.019 3.886 14.969.777-.033-3.863-14.882-.799-.054zm8.983-.462-.748.143 3.808 13.471.478-.136v-.958z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h p",
    d: "M507.666 349.145a4.46 4.342 0 0 1-.684.315v2.514l.209-.12h.475zm-12.6.983v2.576l.684.121v-2.575zm6.363.385-.685.028v2.573l.685-.026z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f g",
    d: "M500.85 268.938h1.35m-1.383-.75h1.349m-1.383-.751h1.349m-1.383-.751h1.35m-1.384-.75h1.35m-1.383-.752h1.349m-1.383-.75h1.35m-1.384-.751h1.35m-1.383-.751h1.349m-1.383-.75h1.35m-1.384-.752h1.35m-1.383-.75h1.349m-1.383-.751h1.349m-1.383-.75h1.35m-1.383-.752h1.349m-1.383-.75h1.349m-1.383-.751h1.35m-1.383-.75h1.349m-1.383-.752h1.349m-1.383-.75h1.35m-1.383-.751h1.349m-1.383-.75h1.349m-1.383-.752h1.35m-1.384-.75h1.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M499.073-36.57c-16.031-2.119-21.099-.553-21.836-.276-.737.277-11.056 3.133-15.11 9.95-4.054 6.817-.921 9.398-.921 9.398-.737-1.566 1.935-7.371 1.935-7.371-1.29 2.395.369 6.449.369 6.449-.553-1.198.645-4.791.645-4.791l.921 2.856c0-1.658.829-5.62.829-5.62.092 5.159 1.106 6.081 1.106 6.081-.921-1.29.645-9.213.645-9.213-.921 4.699.553 5.712.553 5.712 0-5.528 2.672-8.384 2.672-8.384-2.856 3.225-.829 7.923-.829 7.923.276-5.436 4.422-9.766 4.422-9.766-3.87 4.146-1.566 6.91-1.566 6.91.092-3.501 6.081-8.568 6.081-8.568-2.58 2.488-2.488 5.528-2.488 5.528 1.013-1.935 4.883-5.712 4.883-5.712-.921 1.29-1.751 4.699-1.751 4.699l1.198-.737 3.317-4.054-2.027 3.133 2.027-.921 2.303-2.119-1.013 1.382 1.658-.461 1.658-1.935-1.013 1.382h2.395l1.013-1.013-.461 1.106 1.751.092.553-1.013-.092 1.013h.829l.737-1.474-.276 1.474s1.935 0 2.303.461c.368.461-11.793 3.777-11.793 3.777s2.672 0 2.856.737c.184.737-6.081 1.751-6.081 1.751l3.04 1.29-6.081.829 4.422.553-7.647 1.843h7.002l-7.371 1.474 4.699.645-6.173.921 5.897.553-6.357 2.672 3.409-.553c-6.726 6.449-4.33 11.056-4.33 11.056.461-2.027 3.501-6.726 3.501-6.726-.737 5.989.921 8.108.921 8.108.184-1.658 2.303-10.135 2.303-10.135.369 1.935.553 7.463.553 7.463 1.566-1.29.921-7.739.921-7.739l2.488 2.395c-1.198-2.027-.921-6.726-.921-6.726.737.829 1.658 4.054 1.658 4.054l.829-6.173c0 1.935 1.474 5.712 1.474 5.712l.553-6.449c.092 1.566 1.843 4.699 1.843 4.699v-7.002l1.198 3.133.184-4.883.553 5.712 1.013-1.198-.829-.092.369-.184 1.013-5.62 1.566 2.58.553-1.658-.369-2.672c.553.184 1.382 1.843 1.382 1.843v-3.409l1.474.645 2.211-3.225-1.382 2.58 2.119-1.29-2.488 1.935 1.566.645-3.501.369v.921l3.133.276c-4.422.737-4.515 2.027-4.515 2.027l4.238-.184c-3.317-.092-5.712 2.303-5.712 2.303l5.067-.184c-4.699.369-6.634 2.211-6.634 2.211l5.897.369c-2.948-.276-6.173 2.948-6.173 2.948l3.87.092c-3.593.369-4.422 2.395-4.422 2.395l3.133.092c-3.225 1.843-3.409 4.975-3.409 4.975l3.593-2.856c-3.777 3.317-2.488 6.081-2.488 6.081l2.303-2.672c-3.225 3.133-2.488 5.344-2.488 5.344l2.395-2.58c-1.198 7.831.461 8.016.461 8.016l.553-7.924c2.027 1.013 3.317 5.62 3.317 5.62l-1.751-7.279c1.935 1.382 2.488 4.238 2.488 4.238.737-3.317-2.303-7.647-2.303-7.647l3.777 4.791-2.856-7.279 3.317 4.975c.092-4.699-2.58-7.647-2.58-7.647l4.054 3.501c-.184-1.474-2.303-5.344-2.303-5.344.829.645 2.395 2.58 2.395 2.58-.553-2.303-2.856-4.975-2.856-4.975 1.106.276 2.948 2.58 2.948 2.58 0-1.29-1.29-6.081-1.29-6.081l1.382 2.948-.553-4.791 1.198 1.843-.276-3.317.829.184.553-3.962-.276 4.054-.921-.369.276 3.225 2.856-3.133-1.658 5.62 2.856-2.672-2.303 4.883 3.317-3.87-2.488 6.357 2.672-2.303-2.488 4.607c1.382 0 4.146-3.04 4.146-3.04-1.382.829-3.409 5.897-3.409 5.897 1.751 0 2.948-3.133 2.948-3.133l-2.856 5.252c1.751-.553 3.685-3.87 3.685-3.87.369 1.843-3.04 7.831-3.04 7.831 1.106 0 2.856-1.474 2.856-1.474s.276-1.198-.921 1.013-3.962 4.883-3.962 4.883c2.395.092 4.699-3.133 4.699-3.133.369 1.474-2.856 7.279-2.856 7.279 2.303-.184 4.238-6.634 4.238-6.634.737.829 1.198 8.292 1.382 7.371.184-.921.092-10.135.092-10.135.461.645 2.344 4.863 2.344 4.863.137-2.06-2.06-10.024-2.06-10.024l2.609 4.806-3.158-9.201 3.845 4.669-4.806-9.338 2.472 3.708c-.824-6.317-4.944-6.317-4.944-6.317 4.944-.687 5.356 5.493 5.356 5.493 1.099-.275.961-3.433.961-3.433l.275 1.511.824 5.218.549-4.532v5.63c0 .549 1.648-3.296 1.648-3.296.412.687.412 5.356.412 5.356l1.373-3.708c.824 2.197.275 5.905.275 5.905 1.373 0 1.785-3.296 1.785-3.296l1.648 4.806-.137-3.57c-.137-3.57-4.944-10.574-6.179-11.26-1.235-.686-6.042-2.197-6.042-2.197l-4.532-4.257 4.532 4.257c.549-.687-.549-4.12-.549-4.12l3.57 4.669c.824-1.648-.824-4.394-.824-4.394 1.099 1.236 4.257 5.767 4.257 5.767.412-1.648-.824-5.356-.824-5.356.961.961 4.394 6.591 4.394 6.591-.137-.549-2.06-6.179-2.06-6.179 2.334 2.06 4.669 8.651 4.669 8.651.687-2.197-.961-7.965-.961-7.965l3.982 9.475c.412-1.923-.275-5.767-.275-5.767 1.236 1.099 3.296 6.042 3.296 6.042-.275-2.884-1.099-6.454-1.099-6.454l3.57 6.591-.687-4.394 2.197 4.806-1.099-4.257 3.021 4.257-2.472-4.532 3.57 3.57s-5.218-6.454-6.317-7.415c-1.099-.961-10.848-4.532-13.046-5.63-2.198-1.098-11.81-.549-11.81-.549l2.884-.137-.549-1.236.549 1.099h1.923l-1.099-1.099.824 1.236h3.296l-2.197-1.923c1.099.549 2.197 1.785 2.197 1.785l1.648.137-1.099-2.334 1.648 2.609 2.746.549c-.412-1.236-2.06-3.158-2.06-3.158 1.099 1.099 2.472 3.296 2.472 3.296l2.334.824c0-1.236-1.923-3.982-1.923-3.982 1.648 1.373 3.021 4.257 3.021 4.257.137-1.099-.824-4.394-.824-4.394 1.099.687 2.884 4.944 2.884 4.944.137-1.236-.137-4.944-.412-4.806.824.961 2.609 5.905 2.609 5.905v-4.806c.549 0 2.06 5.218 2.06 5.218.824-1.923-.137-5.905-.137-5.905.687 1.373 2.197 5.767 2.197 5.767l.275-1.922.412 3.57.412-3.021 1.236 3.296c-.137-1.923-1.648-7.141-1.648-7.141 1.099 1.099 3.982 7.553 3.982 7.553v-2.334l.824 3.708c1.236-3.708-1.373-7.827-1.373-7.827 1.923 2.746 2.609 6.317 2.609 6.317l.824-1.923c.824 1.373.824 4.944.824 4.944 1.099-3.845-1.099-7.278-1.099-7.278 2.334 1.785 3.708 9.063 3.708 9.063l.412-5.63c.687 1.373 1.99 5.651 1.99 5.651.313-2.383-.69-6.395-2.006-8.151-1.316-1.756-2.383-3.574-10.659-5.329s-28.277-.251-28.277-.251l3.198-.69c2.069-1.63 6.834-.251 6.834-.251l1.191.063-.251-1.881c-.063-.502 2.257 1.63 2.257 1.63l.815.063v-2.383l3.386 2.571 1.254.188-2.194-2.947c1.254 1.191 5.016 2.696 5.016 2.696-.251-1.066-3.072-3.323-3.072-3.323.94 0 4.828 3.511 4.828 3.511l-2.32-2.696 5.58 2.633c-.376-.69-2.257-2.633-2.257-2.633 2.194 2.006 6.709 3.198 6.709 3.198l-5.329-4.264 6.646 5.204c-1.066-3.26-4.326-6.145-4.326-6.145 1.63.251 7.837 6.395 7.837 6.395 0-2.445-2.32-5.329-2.32-5.329 1.63.564 5.768 6.207 5.768 6.207.188-1.505-2.194-5.455-2.194-5.455 1.254.627 4.64 5.518 4.64 5.518.752-2.821-2.445-5.329-2.445-5.329l6.419 3.526c-3.347-5.02-10.103-6.694-10.908-7.004-.805-.31-6.756-.31-11.9-.124s-11.714 3.161-12.024 3.223c-.31.062-5.578 1.673-5.578 1.673l-1.426-.558 1.797.434 2.479-.682-2.479-1.549 3.223 1.24 1.673-.62-2.417-1.426 2.603 1.178 3.843-1.426-4.401-1.673 6.942.062-5.268-1.859 8.553 1.426c-.744-.93-3.161-1.735-3.161-1.735 1.735 0 5.702.93 5.702.93-.744-.868-4.153-2.417-4.153-2.417 1.859.372 6.818 1.859 6.818 1.859l-3.657-2.541 3.533 1.364c-.62-1.116-2.603-2.045-2.603-2.045.806 0 6.756 2.913 6.756 2.913-1.302-2.107-4.153-5.082-4.153-5.082l3.657 2.293-2.107-2.417 5.454 2.541c-1.859-2.603-6.012-4.091-7.252-4.277-1.24-.186-9.979.806-16.858 5.702-6.879 4.896-7.685 9.421-7.685 9.421s-7.051-15.28-19.397-16.201c0 0 1.935 1.843 5.712 2.672 0 0-4.146.921-5.159 2.395 0 0 4.607-.369 7.555.461 0 0-4.883 1.013-5.62 2.303 0 0 5.252-.553 8.016-.092 0 0-4.699.645-4.883 1.751 0 0 7.279 0 7.555 1.382 0 0-4.975-.184-6.265.645 0 0 6.541.921 7.831 1.843l-4.054.645s5.252 1.106 5.897 2.58c0 0-11.609-5.067-21.099-6.081-9.49-1.014-12.346 1.474-14.004 2.856-1.658 1.382-5.436 4.975-4.791 7.923 0 0 2.027-3.962 6.91-7.094l-4.422 5.344 4.975-4.054s-3.04 4.146-3.04 5.528c0 0 4.699-7.647 6.726-9.029 0 0-3.409 4.33-3.317 5.989 0 0 6.541-6.449 7.186-6.357 0 0-4.975 4.515-4.883 7.463 0 0 5.712-6.081 7.463-6.634 0 0-4.33 2.488-3.501 4.607l4.699-4.33-2.856 4.607 1.382-.461s2.027-3.87 4.883-3.777l-3.777 3.593 1.935-.184s2.211-2.764 4.883-3.685c0 0-3.87 3.133-4.054 3.685l1.198.092s2.303-2.395 4.054-2.856l-1.658 2.672h.829l2.211-2.119-1.566 2.027 2.027.184 1.474-1.29-1.198 1.474h1.474l.921-.737-.092.921 2.395.092.645-1.29-.092 1.106z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m488.754-36.478-1.658 1.934-.184.051v.226s-6.449 2.395-11.24 6.541c-4.791 4.146-7.739 8.753-8.292 10.964-.553 2.211-.645 8.384-.645 8.384s.921-5.16 1.474-5.897c0 0 0 3.225.461 3.962l.553-6.449s.184 4.607 1.197 5.067c0 0-.276-5.805.461-7.647 0 0-.276 3.133.277 3.962 0 0 .829-7.279 2.764-9.214 0 0-2.303 3.778-.829 9.122l.444-2.037-.628.102.667-.28.622-2.852.923 2.202.373-.156.233-1.917-2.357-.221 2.824-.421.031-.955-1.381-.189 1.395-.279.038-1.195h-1.065l1.073-.258.032-1.032.12.995 1.513-.365.21-.999.207.898.123-.03.254-1.567-.308-.039.321-.044.232-1.431.181 1.375.715-.098.394-2.013.461 1.842s1.198-3.962 2.119-4.422l.073 2.411.43-.082 1.985-3.435-.036 1.121.781-.217.822-1.918.553 1.474.922-1.106.436.776 7.671-2.619c-.369-.461-2.303-.461-2.303-.461l.276-1.474-.737 1.474h-.829l.092-1.014-.553 1.014-1.751-.092.461-1.106-1.013 1.014h-2.396zm-3.451 5.827-.05 1.543.639-1.492a11.09 11.09 0 0 0-.59-.052zm-6.109 4.678.171 1.299.217-.052.229-1.17zm-2.722 2.301.135 1.121 1.011-.202.192-.918zm.208 1.726.097.805.519-.077.131-.625zm-.841 1.546.292 1.242.039-1.211zm1.039.097.082.684.139-.663zm-1.468 2.489-.066.011.05.119z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i m",
    d: "m500.687 233.868-.643 8.626 1.079 1.938s.122-.656.697-1.703l-.282-8.521a7.065 6.877 0 0 0-.85-.34zm1.208 11.142-.322.067.327.088z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M472.783 323.153s3.056-1.7 4.803-.07l-.582 1.203-2.984.213z",
    strokeWidth: 0.228
  }), /*#__PURE__*/React.createElement("g", {
    fill: "green"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m470.708 58.891-.076 5.949.761.007.076-5.95z",
    strokeWidth: 0.164,
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M468.08 65.611s.773.32.618 1.471-.464 5.31 2.472 5.31 2.55-4.03 2.55-4.67.232-1.855.232-1.855v-2.303s-2.936 2.175-5.872-.064z",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.893 325.38s-.186 1.113-.186 2.23c0 .558.043 1.117.193 1.558.075.221.176.415.335.568a.94.94 0 0 0 .12.094c.199-.002.377-.026.534-.071l-.01-.195a.29.29 0 0 1-.247-.098 1.053 1.053 0 0 1-.23-.409c-.127-.372-.176-.908-.176-1.447 0-1.078.183-2.172.183-2.172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M477.525 324.441c-2.116.673-3.652.453-4.651.079v.144a.87.87 0 0 0 .433.483c1.96.926 3.493.175 4.239-.361z",
    strokeWidth: 0.119
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M461.87 110.61c-.658-1.711-6.054-1.579-10.266-.263s-6.58.921-15.661 1.053-14.214 2.237-15.003 2.501-14.477 6.975-19.741 8.686-10.266 0-10.266 0 6.054 5.922 14.609 1.184c0 0-7.107 3.948-11.713 4.475 0 0 6.874 1.441 12.684-1.069a13.95 13.95 0 0 0 1.53-.773c3.637-1.807 6.878-3.209 9.805-4.297 16.652-6.193 23.129-2.249 34.547-5.179",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.84 110.358c-.781 1.513-5.259.665-8.137 1.602.694.609 2.67 1.68 8.227 2.743.921-3.458-.09-4.345-.09-4.345z",
    strokeWidth: 0.338,
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M417.21 121.79c-5.348 1.807-7.931 3.472-10.858 4.561m10.2-5.562c-4.641 1.649-7.306 3.231-10.154 4.328m9.496-5.329c-3.934 1.49-6.681 2.989-9.449 4.095m8.791-5.096c-3.228 1.331-6.056 2.748-8.745 3.862m8.087-4.864-8.04 3.63",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M423.48 119.14s7.491-2.261 13.285-1.555m-12.437.141s7.031-1.979 13.215-1.449m-12.367.035s6.572-1.696 13.144-1.343m-12.296-.071s6.113-1.413 13.073-1.237m-12.225-.177s5.653-1.131 13.003-1.131",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m446.8 112.214 6.778-1.316c2.895-.418 5.804-.595 6.649.185m-14.063 2.333s3.948-.442 7.133-1.234m-7.769 2.435s4.516-.059 7.488-1.152m-8.124 2.353s5.085.324 7.842-1.071m-8.482 2.158s5.659.631 8.206-.883",
    transform: "matrix(.796 0 0 .775 100.07 273.8)"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "h m",
    d: "m461.367 360.433-1.428 6.14c9.533 4.31 36.416 4.507 38.918 4.516v.003l.241-.002.235.002v-.003c2.508-.009 30.205-.2 39.751-4.515l-1.428-6.14s-1.19 3.939-38.561 4.633c-37.37-.695-37.728-4.634-37.728-4.634z",
    stroke: "#000"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M455.74 112.4c-.607-1.578-5.583-1.456-9.467-.243s-6.068.85-14.443.971-13.108 2.063-13.836 2.306-13.351 6.433-18.205 8.01-9.467 0-9.467 0 5.583 5.462 13.472 1.092c0 0-6.554 3.641-10.802 4.127 0 0 6.339 1.329 11.697-.986.48-.207.952-.444 1.411-.713 3.354-1.667 6.343-2.959 9.042-3.963 15.357-5.712 21.329-2.074 31.859-4.776",
    transform: "matrix(-.864 0 0 .84 924.56 265.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M414.55 122.71c-4.932 1.667-7.314 3.202-10.013 4.206m9.406-5.129c-4.28 1.52-6.738 2.979-9.363 3.991m8.757-4.915c-3.628 1.374-6.161 2.757-8.714 3.776m8.107-4.7c-2.976 1.228-5.585 2.534-8.064 3.562m7.458-4.485-7.415 3.347",
    transform: "matrix(-.864 0 0 .84 924.56 265.06)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M420.336 120.264s6.908-2.085 12.252-1.434m-11.47.13s6.484-1.825 12.186-1.336m-11.404.033s6.061-1.564 12.121-1.238m-11.339-.065s5.637-1.303 12.056-1.14m-11.274-.163s5.213-1.043 11.991-1.043",
    transform: "matrix(-.864 0 0 .84 924.56 265.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m441.841 113.877 6.25-1.213c2.67-.386 5.352-.549 6.132.17m-12.968 2.151s3.641-.407 6.578-1.138m-7.165 2.246s4.165-.054 6.905-1.063m-7.491 2.171s4.689.299 7.232-.988m-7.823 1.99s5.219.582 7.568-.815",
    transform: "matrix(-.864 0 0 .84 924.56 265.06)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M455.711 112.166c-.72 1.395-4.85.613-7.504 1.477.64.562 2.462 1.55 7.587 2.53.849-3.189-.083-4.007-.083-4.007z",
    strokeWidth: 0.312,
    transform: "matrix(-.864 0 0 .84 924.56 265.06)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m467.714 363.843-.552-.103-.788 3.987 2.63.493.095-.478-2.079-.389zm2.177 1.85.417.066.238-1.423-.417-.066zm4.036-.882-.357 2.542q-.045.326-.167.521-.127.206-.307.308-.359.192-.769.132-.182-.024-.36-.106-.175-.079-.315-.223-.131-.143-.194-.374-.068-.226-.023-.552l.355-2.531-.557-.074-.377 2.685q-.088.582.239 1.052.324.484 1.147.604.853.102 1.323-.287.465-.378.554-1.011l.366-2.61zm3.72 3.699-.011-.001-1.725-3.471-.663-.067-.432 4.039.542.055.35-3.263.011.001 1.762 3.478.629.064.432-4.039-.545-.055zm2.356-3.088-.562-.047-.36 4.045.562.047zm4.011 2.331q-.059.721-.471 1.152-.416.437-1.098.395-.684-.053-1.027-.542-.354-.485-.301-1.206.053-.733.475-1.158.41-.431 1.095-.389.682.053 1.031.537.346.478.298 1.211zm.577.04q.025-.339-.038-.717-.077-.379-.287-.712-.208-.344-.581-.575-.388-.223-.965-.269-.286-.02-.533.013-.247.036-.45.121-.405.177-.667.488-.252.301-.379.666-.132.364-.157.703-.024.328.054.702.072.373.277.717.214.342.589.572.373.236.953.282.295.02.542-.026.247-.033.452-.121.403-.177.659-.486.256-.312.388-.671.117-.36.142-.688zm3.321 1.42h-.011l-1.906-3.38-.666-.034-.219 4.055.544.028.177-3.276h.011l1.943 3.385.632.033.219-4.055-.547-.028zm3.689-.917 2.045.064.016-.486-2.045-.064.041-1.242 2.322.073.016-.486-2.887-.091-.135 4.058.565.018zm4.8.784.388 1.189.616.012-1.429-4.087-.638-.012-1.649 4.03.579.011.46-1.174zm-1.491-.514.705-1.774h.011l.58 1.798zm3.723-2.34-.565-.004-.034 4.06.565.004zm.397.494 1.41-.018.048 3.573.565-.007-.048-3.573 1.413-.018-.007-.486-3.387.043zm6.047-.597-.562.017.13 4.058 2.677-.081-.016-.486-2.115.064zm5.079 2.695.464 1.164.615-.026-1.689-3.992-.638.027-1.386 4.122.578-.025.384-1.199zm-1.521-.422.589-1.813.011-.001.695 1.759zm5.237-.436 2.041-.127-.032-.485-2.041.127-.082-1.24 2.319-.145-.032-.485-2.882.18.267 4.052.563-.035zm6.134-.63q.056.722-.284 1.209-.342.493-1.023.554-.685.05-1.1-.382-.426-.426-.488-1.147-.063-.732.286-1.215.337-.488 1.021-.548.682-.05 1.102.376.417.421.486 1.152zm.577-.046q-.029-.339-.151-.702-.136-.363-.395-.661-.26-.309-.664-.481-.418-.163-.996-.122-.286.023-.525.092-.239.072-.425.187-.373.235-.582.582-.202.335-.269.715-.073.38-.044.719.028.327.164.685.131.358.387.667.265.305.673.478.405.178.985.136.294-.024.532-.107.239-.069.428-.187.37-.235.574-.578.204-.347.277-.721.059-.374.031-.701zm1.274.16 1.356-.143q.249-.026.41.02.154.045.239.144.088.094.124.22.031.127.045.257.015.137.075.464.031.152.064.296.034.143.072.243l.688-.073-.01-.091q-.129-.058-.181-.139-.049-.081-.072-.243l-.115-.726q-.034-.208-.087-.343-.061-.133-.139-.196-.077-.078-.164-.113-.092-.032-.192-.055.096-.066.19-.162.091-.084.166-.201.075-.122.108-.284.028-.161.003-.381-.081-.627-.517-.82-.434-.181-.967-.12l-1.918.203.452 4.036.562-.06zm-.205-1.837 1.396-.148q.231-.03.491.048.123.051.214.178.092.132.118.368.025.219-.031.361-.054.15-.168.234-.113.087-.26.125-.146.049-.307.066l-1.301.138zm6.971-.104q-.134-.52-.612-.847-.475-.333-1.278-.233-.906.137-1.325.773-.428.643-.294 1.589.179 1.144.823 1.565.618.422 1.35.315.127-.018.379-.091.252-.077.523-.262.273-.192.466-.556.194-.359.205-.926l-.542.075q-.018.351-.12.588-.106.238-.265.38-.158.136-.322.209-.167.071-.311.091-.753.099-1.136-.339-.378-.422-.478-1.147-.111-.794.226-1.254.315-.448.891-.529.16-.022.338-.025.176.009.358.076.179.067.335.216.156.146.249.406zm4.114 1.647-2.469.459-.262-1.335 2.244-.417-.094-.478-2.244.417-.24-1.221 2.43-.452-.094-.478-2.985.555.783 3.988 3.024-.563z",
    letterSpacing: 0,
    wordSpacing: 0
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "m466.579 21.667 7.546 15.955 1.725-.862 13.475 25.442.108-4.312-12.782-22.496.599-.466-.862-.97-.418.239-.013-.023s-.862-.107-.97.216z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "m466.579 21.667 7.546 15.955 1.725-.862-.909-2.442zm15.287 22.904c-.439.159-1.091.417-1.514.688l1.86 3.513c.308-.229.904-.617 1.507-.692a.206.206 0 0 0 .112-.049z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "m476.389 33.957-.389.222.665 1.204.586-.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "m466.579 21.667 7.546 15.955 1.725-.862-.909-2.442z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "m471.5 15.643 5.918 16.628 1.802-.686-.661-2.521z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "m480.036 28.85-.409.182.542 1.264.629-.395z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M482.779 36.234c-.521.143-.987.471-1.345.781l1.432 3.511c.43-.265.995-.505 1.505-.695z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "m471.5 15.643 5.918 16.628 1.802-.686 10.871 26.659.537-4.28-10.475-23.659.643-.404-.761-1.052-.44.196-.011-.024s-.847-.193-.987.118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M531.908 13.848c-1.863.819-3.542.164-3.542.164s-.819 1.065 1.392 1.187c0 0 .88.082.287 1.065"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M534.529 11.944s-3.337-2.723-5.446-2.559-2.211.123-2.395.491-.553 2.068.389 3.317 1.331.942 1.495.676 1.495-1.044 4.013-.471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M529.284 9.378a2.43 2.43 0 0 0-.201.007c-2.109.164-2.211.123-2.396.491-.127.254-.341 1.138-.155 2.072.315-.302.964-.588 2.304-.516 2.662.143 4.218 1.229 4.218 1.229l.263.188 1.211-.905s-3.132-2.555-5.245-2.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M511.016 41.954s2.949 6.765 2.486 15.496l17.809-16.594 8.5-7.69-.173.116-1.099-5.319-.52-3.007-1.388.347v-1.735l-.231-1.503-1.214-2.371-.983-2.544-.231-2.139.463-2.544-.636.289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M563.748 43.227s1.735 1.735 1.966 5.666l.173 6.649s-2.833 1.677-5.493.983c0 0 .463-1.156.52-2.775s-.058-10.003-.058-10.003z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "m562.13 43.747-1.271.085.057 9.918c-.058 1.619-.52 2.776-.52 2.776.973.254 1.968.189 2.84.006l.282-7.638c-.058-2.602-1.388-5.146-1.388-5.146z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M584.629 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.106-.319-1.118-.213-1.756-.213-1.756c.16-5.376-.373-6.813-.373-6.813.373 0 2.076 2.023 2.076 2.023-.053-5.11-7.611-7.505-7.611-7.505 2.768 7.026 1.703 7.824 1.703 7.824 1.756-.745 1.969-1.916 1.969-1.916.319 1.916.053 5.642.053 5.642s.106 1.756-1.544.905-8.303-4.045-8.303-4.045l-.692 1.384 9.155 4.258s1.331.585.958 1.597-.585 1.171-.585 1.171z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "M583.884 109.486s.266-3.726-.053-5.642c0 0-.213 1.171-1.969 1.916 0 0 1.065-.798-1.703-7.824 0 0 7.558 2.395 7.611 7.505 0 0-1.703-2.023-2.076-2.023 0 0 .532 1.437.373 6.813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M584.629 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.106-.319-1.118-.213-1.756-.213-1.756c.16-5.376-.373-6.813-.373-6.813.373 0 2.076 2.023 2.076 2.023-.053-5.11-7.611-7.505-7.611-7.505 2.768 7.026 1.703 7.824 1.703 7.824 1.756-.745 1.969-1.916 1.969-1.916.319 1.916.053 5.642.053 5.642s.106 1.756-1.544.905-8.303-4.045-8.303-4.045l-.692 1.384 9.155 4.258s1.331.585.958 1.597-.585 1.171-.585 1.171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M570.684 104.471a1.63 1.63 0 0 0-.977.32c-.174.136-.322.344-.367.609s.01.576.184.938c.36.75 1.077 1.025 1.664 1.104s1.084-.023 1.084-.023l-.088-.441s-.434.085-.937.018-1.038-.271-1.316-.852c-.146-.304-.172-.519-.146-.668s.095-.245.201-.328c.211-.166.59-.225.699-.225.185 0 .344-.029.645.121s.73.497 1.303 1.277l.363-.268c-.598-.816-1.073-1.216-1.465-1.412s-.711-.17-.846-.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M571.376 109.274s.213-3.513 2.448-4.737c0 0 .532.053.585.479s-2.076 4.152-2.076 4.152z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M571.629 108.879s.177-2.927 2.04-3.947c0 0 .443.044.488.399s-1.73 3.459-1.73 3.459z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M581.874 75.422s4.03.232 3.983 2.223-.648 3.937.695 4.307 4.122.371 4.817 1.112.695 1.575.695 1.575-3.474-1.251-5.002-.371-3.128-.509-3.381-.973c-.556-1.019-.232-3.011-1.297-3.381s-4.446-.417-4.446-.417z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    d: "m543.911-1.2-4.364 10.177s-1.269-1.289-2.296.048l-1.024 1.333m7.668-11.57-8.424 7.188s1.607.829.635 2.207l-.969 1.373 1.089.802"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M493.05-199.53h7.427v2.665h-7.427z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "M493.54-199.08h6.431v1.755h-6.431z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M552.991 23.897s-5.495-1.051-6.834-.239 2.342.86 3.058.621l-1.386 1.386s-3.154-.765-3.68-3.727 1.577-2.963 2.055-2.915 3.25.478 6.786 4.874z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    d: "M545.101 20.784c-.604.179-1.059.604-.903 1.393 0 0 .239.908.478 1.386a.3.3 0 0 1 .073-.084c.181.283.387.534.606.753l.539-.177c-.068-.105-.003-.235.264-.397a1.86 1.86 0 0 1 .587-.204c.998-.383 2.491.014 2.806-.035l1.673.096s-4.979-3.07-6.121-2.731z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M552.275 23.853c-.143.69-.301 1.596-.22 2.002 1.79 4.572 4.223 4.671 3.269 10.226l1.885-.053c.203-2.577-.203-5.018-.678-6.104-.237-.543-.763-1.187-1.339-1.814s-1.204-1.238-1.645-1.713c-.882-.949-.271-2.17-.271-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M551.106 23.414s-.332.874-.332 2.1c0 .613.083 1.314.332 2.037s.46 1.44.633 2.233c.347 1.587.542 3.486.588 6.38l2.998-.083c.954-5.555-1.479-5.654-3.269-10.226-.081-.406.077-1.313.22-2.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M553.276 24.228s-.61 1.221.271 2.17l1.645 1.712c.576.627 1.102 1.272 1.339 1.814.475 1.085.882 3.527.678 6.104m0 0-4.883.136c-.045-2.894-.241-4.793-.588-6.38a19.6 19.6 0 0 0-.633-2.233 6.26 6.26 0 0 1-.332-2.037c0-1.226.332-2.1.332-2.1l2.17.814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m548.427 80.397-4.217 7.381-16.666 1.24-1.575.212s-2.434 5.738-5.137 6.502-20.781 6.402-20.781 6.402l-.556-4.133 11.715-3.78s3.437-1.264 4.459-2.604 9.543-9.5 9.543-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M540.471 63.209s.684.648 1.533-.389 3.332-5.311 3.807-6.089 1.087-1.425.281-1.943-1.936.13-2.864 2.073-3.98 5.311-2.756 6.348z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M218.18 61.609c-.87 0-2.104 1.868-2.104 4.826s.705 5.355 1.575 5.355c.318-.002.628-.332.89-.945h46.514l-.199-8.761-46.052.712c-.298-1.091-.186-1.183-.624-1.185z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M263.025 62.156s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758m-.727-.741s-.207.466-.277.758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M225.229 61.961a4.853 1.472 86.347 0 0-1.157 4.948 4.853 1.472 86.347 0 0 1.781 4.738 4.853 1.472 86.347 0 0 .43-.266 4.853 1.472 86.347 0 1-1.257-4.472 4.853 1.472 86.347 0 1 .726-4.682 4.853 1.472 86.347 0 0-.525-.266z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m265.469 64.91 2.557-.521s1.657.331 1.846.994.379 1.657.284 1.941-3.03 1.231-4.214.426z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M269.872 65.383c-.998.392-2.832.535-4.226.588l.297 1.78c1.184.805 4.119-.142 4.214-.426s-.095-1.279-.284-1.941z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M264.574 61.882c-.103.006-.201.085-.289.232.346.901.618 2.452.725 4.124.122 1.924.003 3.685-.303 4.516.166.331.337.5.499.495.271-.012.498-.517.63-1.404s.16-2.083.076-3.325-.272-2.428-.522-3.298-.544-1.351-.815-1.339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M443.728 74.86v.033c.553.125.964.615.964 1.207v8.269l-5.847-5.847a1.235 1.235 0 0 1-.172-1.535l-.024-.023-2.533 2.533.01.01a1.23 1.23 0 0 1 1.646.088l5.945 5.945h-8.465a1.235 1.235 0 0 1-1.207-.964h-.033v3.582h.014a1.232 1.232 0 0 1 1.226-1.102h8.408l-5.985 5.985a1.235 1.235 0 0 1-1.536.172l-.023.023 2.533 2.533.01-.01a1.23 1.23 0 0 1 .088-1.646l5.945-5.945v8.465c0 .592-.411 1.082-.964 1.207v.033h3.583v-.014a1.232 1.232 0 0 1-1.102-1.226V88.03l6.083 6.083c.452.452.478 1.159.088 1.646l.01.01 2.534-2.533-.024-.023a1.235 1.235 0 0 1-1.535-.172l-5.985-5.985h8.407c.64 0 1.157.481 1.226 1.102h.014v-3.582h-.033a1.235 1.235 0 0 1-1.207.964h-8.464l5.945-5.945a1.233 1.233 0 0 1 1.646-.088l.01-.01-2.534-2.533-.023.023a1.234 1.234 0 0 1-.172 1.535l-5.986 5.986V76.1c0-.64.481-1.157 1.102-1.226v-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M445.45 71.277a15.09 15.09 0 1 0 0 30.18c8.334 0 15.09-6.756 15.09-15.09s-6.756-15.09-15.09-15.09zm0 3.84c6.213 0 11.25 5.037 11.25 11.25s-5.037 11.25-11.25 11.25-11.25-5.037-11.25-11.25 5.037-11.25 11.25-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M486.18 68.609s-5.88 2.534-6.386-1.825c0 0-3.548 4.46 1.318 7.299 0 0-2.23-3.548 5.069-3.954 0 0 1.014.101.912-.71s-.912-.811-.912-.811z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M487.098 69.561c-.833.073-2.732.283-5.683.873-1.31.262-2.226.099-2.87-.239-.009 1.289.572 2.725 2.566 3.888 0 0-2.23-3.548 5.068-3.954 0 0 .892.089.919-.569z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M472.761 84.818c-.329-.016-.648.039-.736.236-.176.395.351.483.351.483v2.24c0 .703-.571 11.286-.835 13.351a7.648 7.648 0 0 1-.468 1.851s-2.519.301-2.387 1.443 1.494 1.897 3.777 1.845c2.815-.064 3.601-.659 3.733-1.362s-.659-1.361-1.844-1.581l-.615-3.513s.132.527 1.756.176 1.581-2.811 1.581-2.811l-.044-8.74c-.088-1.361-.835-2.02-1.889-2.415-.834-.132-1.405.044-1.493.527s-.307.615-.439.439 0-1.493 0-1.493.615-.307.351-.483c-.132-.088-.472-.176-.802-.192zm2.119 2.52.571.307.176 1.581v7.993l-.088.527-.747.615-.834-.176-.439-.527-.307-7.158-.088-2.284 1.054-.703z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M474.573 104.158s-.966-2.459-1.186-8.915v-7.29c.307-.307 1.186-.834 1.713-.527s.395.395.483 1.493.088 8.213.088 8.213-.264 1.186-.922 1.142-1.142-.307-1.23-.791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M524.804 96.618s-3.224.095-4.267 2.086-.474 3.888.759 4.647 3.888 1.328 5.121.569 2.086-3.224.664-3.509-3.793-.759-3.509-1.707 1.517-.948 1.517-.948z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M583.64 73.375a.375.375 0 0 0-.262.114l-12.924 12.83a.375.375 0 1 0 .53.531l12.704-12.612v-.86a.375.375 0 0 0-.048-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M572.558 84.398a.375.375 0 0 0-.257.113L559.47 97.249l1.123-.057 12.235-12.147a.375.375 0 0 0-.27-.646z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M535.734 13.089s-.188 1.876 1.407 3.002 3.471 2.346 4.222 5.536.188 2.815.188 2.815l-4.973.844s.563-2.252-.657-4.034-3.002-6.943-1.314-9.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M535.576 12.971c-.296.725-.815 2.45.346 3.683 1.501 1.595 2.909 2.346 3.472 4.504a34.58 34.58 0 0 1 .696 3.532l1.462-.248s.563.376-.188-2.814-2.627-4.41-4.222-5.536-1.408-3.002-1.408-3.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M573.904 106.957a.2.2 0 1 0 .063.395s3.398-.534 5.924 2.041a.2.2 0 1 0 .285-.279c-2.671-2.722-6.271-2.156-6.271-2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M579.832 110.797s-.007.534.43 1.047 1.302 1.006 2.963 1.057l.012-.4c-1.587-.049-2.319-.504-2.67-.916s-.334-.777-.334-.777z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M584.629 114.809c.532-1.384 1.969-1.703 1.969-1.703s.106-.106-.319-1.118-.213-1.756-.213-1.756c.16-5.376-.373-6.813-.373-6.813.373 0 2.076 2.023 2.076 2.023-.053-5.11-7.611-7.505-7.611-7.505 2.768 7.026 1.703 7.824 1.703 7.824 1.756-.745 1.969-1.916 1.969-1.916.319 1.916.053 5.642.053 5.642s.106 1.756-1.544.905c-.883-.456-5.161-2.531-5.161-2.531l-.408 1.463 5.729 2.665s1.331.585.958 1.597-.585 1.171-.585 1.171z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "m574.839 106.909.206.405.3.019-.202-.412-.304-.011zm1.013.08.141.419.291.056-.138-.43-.294-.045zm1.092.226.068.435.276.091-.063-.438-.281-.088zm1.091.398-.014.437.257.132.02-.437-.263-.132zm1.006.561-.092.419.232.171.095-.426-.235-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AA",
    d: "m580.476 111.465-.19.404a2.15 2.15 0 0 0 .201.197l.178-.38-.098-.102a1.61 1.61 0 0 1-.09-.119zm.544.498-.051.434a3.3 3.3 0 0 0 .253.119l.049-.417a2.54 2.54 0 0 1-.251-.136zm.634.289.079.441.28.067-.076-.427-.283-.081zm.565.145.187.43.305.039-.184-.425-.307-.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AB",
    d: "M560.742 38.89s-3.007-1.446-3.7-.231-.983 3.643 0 5.088c0 0 4.279.52 6.476-.231l.289-.173z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AC",
    d: "M557.76 40.215c-.478-.011-.934.138-1.296.306-.146 1.11-.02 2.348.576 3.225 0 0 3.789.461 6.066-.112-1.096-.344-2.984-2.154-4.274-3.068a1.894 1.894 0 0 0-1.073-.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AD",
    d: "M563.748 43.227s1.735 1.735 1.966 5.666l.173 6.649s-2.833 1.677-5.493.983c0 0 .463-1.156.52-2.775s-.058-10.003-.058-10.003"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AE",
    d: "M550.79 23.324s-6.124-1.831-6.124-.063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AF",
    d: "m540.959 61.578-24.223 40.371.514.309 24.223-40.371z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AG",
    d: "M217.624 65.849h47.106m-47.106 1.058h47.106m-47.106 1.059h47.106m-47.106.529h47.106m-47.106.529h47.106m-47.106.529h47.106m-47.106.529h47.106m-47.106.529h47.106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AH",
    d: "m483.588 68.572-.494.074 2.027 13.584.494-.074z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AI",
    d: "m483.787 68.543-.891.133.408 2.736.891-.133z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AJ",
    d: "M470.357 104.29s.922-1.098 1.186-3.162.834-12.648.834-13.351v-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AK",
    d: "m570.121 86.252-13.617 7.086.072.138.958.173 12.935-6.733z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AL",
    d: "m570.52 86.586-7.673 13.586 1.244-.68 7.083-12.538z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AM",
    d: "M534.984 12.151s-.938 2.158.094 4.316 2.064 3.19 2.627 4.597 0 2.721.657 3.753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AN",
    d: "M556.463 42.648s1.446-.983 3.758.058 2.313.867 2.313.867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.d44729ab030d3d72209724a27fff3a38.svg";
export { ForwardRef as ReactComponent };